import axios from 'axios';
import appConfig from '../../appConfig';
export const getMetaTagsWithUMOID = async (host, umoId, surl, csrf) => {
  const url = `${host}!soap.jsonget?n=Metatag&SURL=${surl}&CSRF=${csrf}&EXPAND_LIST=TRUE&UMO_ID=${umoId}&TAG_FOR_UMO_EDITED=`;
  try {
    const response = await axios.get(url);
    if (
      response.status == 200 &&
      response.data.metatags &&
      Array.isArray(response.data.metatags) &&
      response.data.metatags.length > 1
    ) {
      return response.data.metatags;
    } else {
      console.log('Error fetching metatags:', response);
      return null;
    }
  } catch (error) {
    console.error('Error fetching metatags:', error);
    return null;
  }
};

export const getMetaValuesWithUMOID = async (host, umoIds, surl, csrf) => {
  const url = `${host}!soap.jsonget?n=IMAGE_QUERY&SURL=${surl}&SEARCH=UMO_IDS:${umoIds}&CSRF=${csrf}
  &SHOW_MASTER_METADATA=TRUE&START=0&ORIGINAL_URLS=TRUE&IS_ADVANCED=FALSE&CHECK_ALTERNATE_REPS=TRUE  
  &FORCE_REFRESH=TRUE&INCLUDE_MASTER_METADATA=FALSE&MAXROWS=${appConfig.umoGallery.umosPerPage}&METADATA=EDIT&RELATED_OBJECTS=TRUE`;

  try {
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (
      response.status == 200 &&
      response.data.r &&
      Array.isArray(response.data.r)
    ) {
      return response.data.r;
    } else {
      console.log('Error fetching metavalues:', response);
      return null;
    }
  } catch (error) {
    console.error('Error fetching metavalues:', error);
    return null;
  }
};

export const updateMetaData = async (
  host,
  umoId,
  surl,
  csrf,
  updatedValueParams
) => {
  const url = `${host}!soap.jsonget?n=METADATA_UPDATE_V2&SURL=${surl}&CSRF=${csrf}
  &UMO_ID=${umoId}&${updatedValueParams}`;
  try {
    const promise = axios.post(url);
    return promise;
  } catch (error) {
    console.error('Error Updating MetaData', error);
    return null;
  }
};
